import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authFetch } from '../utils/authToken';

const API = `${window.location.origin}/api`;

export const AdminRoute = ({ children }) => {
  const location = useLocation();
  const [status, setStatus] = useState('loading'); // loading, authenticated, unauthorized, unauthenticated
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await authFetch(`${API}/auth/me`);

        if (!response.ok) {
          setStatus('unauthenticated');
          return;
        }

        const userData = await response.json();
        setUser(userData);

        if (userData.role === 'admin') {
          setStatus('authenticated');
        } else {
          setStatus('unauthorized');
        }
      } catch (error) {
        setStatus('unauthenticated');
      }
    };

    checkAuth();
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/auth" replace />;
  }

  if (status === 'unauthorized') {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-white mb-4">Access Denied</h1>
          <p className="text-zinc-500 mb-8">You don't have permission to access the admin panel.</p>
          <a href="/dashboard" className="btn-primary inline-block">
            Go to Dashboard
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default AdminRoute;
